import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { MenuItem, Link, } from '@mui/material';
import { NestedMenuItem } from 'mui-nested-menu';
import { Link as RouterLink } from 'react-router-dom';
const StyledNestedMenuItem = styled(NestedMenuItem)(() => ({
    '& .MuiTypography-root': {
        fontWeight: 700,
        fontSize: '14px',
        paddingRight: '0px',
    },
}));
const CategoryMenuItem = ({ category, closeMenu, editData, }) => (_jsx(MenuItem, { id: category.id, sx: { minHeight: { xs: 'auto' } }, children: _jsx(Link, { component: RouterLink, underline: "hover", to: `cat/${category.slug || category.id}`, className: "pageSubMenu", onClick: (ev) => {
            closeMenu();
            editData?.preNavigationHook(`cat/${category.slug || category.id}`, ev);
        }, sx: {
            typography: 'subtitle1',
            fontWeight: 'fontWeightBold',
            letterSpacing: 'normal',
            fontSize: { xs: '14px' },
        }, children: category.name }, category.id) }, category.id));
const CategorySubMenu = ({ category, editData, open, closeMenu, }) => (category.subCategories && category.subCategories.length > 0 ? (_jsx(StyledNestedMenuItem, { label: category.name, parentMenuOpen: open, className: "pageSubMenu", sx: {
        typography: 'subtitle1',
        fontWeight: 'fontWeightBold',
        letterSpacing: 'normal',
        color: (theme) => (theme.portal?.menu?.subMenu?.font?.color),
        padding: 1,
        fontSize: { xs: '14px' },
    }, children: category.subCategories.map((subCategory) => (_jsx(CategoryMenuItem, { category: subCategory, closeMenu: closeMenu, editData: editData }, subCategory.id))) }, category.id)) : (_jsx(CategoryMenuItem, { category: category, closeMenu: closeMenu, editData: editData })));
export default CategorySubMenu;
//# sourceMappingURL=CategorySubMenu.js.map